<template>
  <div class="page-table-fprm-all">
    <a-form
      layout="inline"
      :form="form"
      @submit="handleSubmit"
      class="page-form-queryheder"
    >
      <!-- <a-form-item :label="$tc('lang.orderAll.Order_Type')">
        <a-select
          style="width: 120px"
          @change="handleChange"
          :placeholder="$tc('lang.orderAll.Select_the_order_type')"
          v-decorator="['orderType']"
          allowClear
        >
          <a-select-option value="1">{{
            $tc('lang.menuGoodsSpace.Mid_Term_Inspection')
          }}</a-select-option>
          <a-select-option value="2">{{
            $tc('lang.menuGoodsSpace.Final_Inspection')
          }}</a-select-option>
          <a-select-option value="3">{{
            $tc('lang.menuGoodsSpace.Fabric_Inspection')
          }}</a-select-option>
          <a-select-option value="4">{{
            $tc('lang.menuGoodsSpace.Factory_Evaluation')
          }}</a-select-option>
          <a-select-option value="5">{{
            $tc('lang.menuGoodsSpace.Vendor_Assessment')
          }}</a-select-option>
          <a-select-option value="6">{{
            $tc('lang.menuList.Loading_Supervision')
          }}</a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item :label="$tc('lang.orderAll.Service_Date')">
        <a-date-picker
         style="width: 140px;"
          @change="onDateChange"
          :placeholder="$tc('lang.orderAll.Select_the_date')"
          v-decorator="['dateTime']"
        />
      </a-form-item>
      <!-- <a-form-item :label="$tc('lang.orderAll.Order_status')">
        <a-select
          style="width: 180px"
          @change="handleChange"
          :placeholder="$tc('lang.orderAll.Select_the_order_status')"
          v-decorator="['orderStatus']"
          allowClear
        >
          <a-select-option value="0">{{
            $tc('lang.orderAll.To_be_confirmed')
          }}</a-select-option>
          <a-select-option value="1">{{
            $tc('lang.orderAll.To_be_paid')
          }}</a-select-option>
          <a-select-option value="2">{{
            $tc('lang.orderAll.To_be_assigned')
          }}</a-select-option>
          <a-select-option value="3">{{
            $tc('lang.orderAll.Order_release')
          }}</a-select-option>
          <a-select-option value="4">{{
            $tc('lang.orderAll.To_be_served')
          }}</a-select-option>
          <a-select-option value="5">{{
            $tc('lang.orderAll.Under_inspecting')
          }}</a-select-option>
          <a-select-option value="6">{{
            $tc('lang.orderAll.Under_auditing')
          }}</a-select-option>
          <a-select-option value="7">{{
            $tc('lang.orderAll.To_be_translated')
          }}</a-select-option>
          <a-select-option value="8">{{
            $tc('lang.orderAll.To_be_reviewed')
          }}</a-select-option>
          <a-select-option value="9">{{
            $tc('lang.orderAll.Finished')
          }}</a-select-option>
          <a-select-option value="10">{{
            $tc('lang.orderAll.Draft')
          }}</a-select-option>
          <a-select-option value="11">{{
            $tc('lang.orderAll.Canceled')
          }}</a-select-option>
        </a-select>
      </a-form-item> -->
      <!-- <a-form-item :label="$tc('lang.orderAll.Vendor_name')">
        <a-input
          v-decorator="['vendorName']"
          :placeholder="$tc('lang.orderAll.Vendor_name')"
        >
        </a-input>
      </a-form-item> -->
      <a-form-item :label="$tc('lang.orderAll.Factory_sel')">
        <a-input
        style="width: 140px;"

          v-decorator="['vendorName']"
          :placeholder="$tc('lang.orderAll.Factory_sel')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.PO_Number')">
        <a-input
        style="width: 140px;"

          v-decorator="['productOrderId']"
          :placeholder="$tc('lang.orderAll.PO_Number')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Product_Name')">
        <a-input
        style="width: 140px;"

          v-decorator="['productNames']"
          :placeholder="$tc('lang.orderAll.Product_Name')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Item_Number')">
        <a-input
        style="width: 140px;"

          v-decorator="['itemNumbers']"
          :placeholder="$tc('lang.orderAll.Item_Number')"
        >
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">
          {{ $tc('lang.orderAll.search') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :dataSource="data"
      :customRow="clickHang"
      :scroll="{ x: 1500, y: 485 }"
      style="
         width: 97%;
         margin: 20px;
        border: 1px solid #dbdbdb"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <span slot="actionOne" slot-scope="record">
        <a-button
          type="primary"
          size="small"
          v-if="record.orderState === '1' || record.orderState === '0'"
          style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
          @click.stop
          @click="action(record, 2)"
          :disabled="
            record.orderState !== '1' ||
              record.orderServicechargeusd === null ||
              record.orderServicechargermb === null
          "
          >{{ $tc('lang.orderAll.Pay') }}</a-button
        >
        <a-button
          type="primary"
          size="small"
          v-if="
          record.orderState < '8' &&
          record.orderState !== '8' &&
            record.orderState !== '9' &&
              record.orderState !== '0' &&
              record.orderState !== '1' &&
              record.orderState !== '10' &&
              record.orderState !== '11'
          "
          style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
          @click.stop
          @click="queryReportList(record)"
          >{{ $tc('lang.orderAll.View_Report') }}</a-button
        >
        <a-button
          type="primary"
          size="small"
          v-if="
              record.orderState == '8' ||
              record.orderState == '9'
          "
          style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
          @click.stop
          @click="queryReportList(record)"
          >{{ $tc('lang.orderAll.down_Report') }}</a-button
        >
        <a-button
          type="primary"
          size="small"
          v-if="record.orderState == '10'"
          style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
          @click.stop
          @click="action(record, 1)"
          >{{ $tc('lang.orderAll.Edit') }}</a-button
        >
       
        <a-popconfirm
          title="确定要取消订单吗？"
          okText="确定"
          cancelText="取消"
          v-if="record.orderState === '0' || record.orderState === '1'"
          @confirm="onOrderState(record, 5)"
          @cancel="cancelButton()"
        >
      
          <a-button
            size="small"
            type="default"
            style="
        border: 1px solid #dbdbdb;
        display: inline-block;
"
            @click.stop
           :disabled="!(record.orderState === '0' || record.orderState === '1')"
            >{{ $tc('lang.orderAll.Cancel') }}</a-button
          >
        </a-popconfirm>
        <a-button
        v-if=" Number( record.orderState) <=10 &&!(record.orderState === '0' || record.orderState === '1')"
            size="small"
            type="default"
            style="
        border: 1px solid #dbdbdb;
        display: inline-block;
"
            @click.stop
           :disabled="!(record.orderState === '0' || record.orderState === '1')"
            >{{ $tc('lang.orderAll.Cancel') }}</a-button
          >
       
        <a-popconfirm
          title="确定要恢复订单吗？"
          okText="确定"
          cancelText="取消"
          v-if="record.orderState === '11'"
          @confirm="action(record, 3)"
          @cancel="cancelButton()"
        >
          <a-button
            type="primary"
            size="small"
            @click.stop
            v-if="record.orderState === '11'"
            style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
            >{{ $tc('lang.orderAll.Recover') }}</a-button
          >
        </a-popconfirm>
        <a-popconfirm
          title="确定要删除订单吗？"
          okText="确定"
          cancelText="取消"
          v-if="record.orderState == '11'"
          @confirm="onOrderState(record, 4)"
          @cancel="cancelButton()"
        >
          <a-button
            size="small"
            type="default"
            style="
        border: 1px solid #dbdbdb;
        display: inline-block;
"
            @click.stop
            v-if="record.orderState > '10'"
            >{{ $tc('lang.orderAll.Delete') }}</a-button
          >
        </a-popconfirm>
      </span>
      <span slot="orderServicedate" slot-scope="text, record">{{
        $momentData(record.orderServicedate)
      }}</span>
      <span slot="orderDate" slot-scope="text, record">{{
        $momentData(record.orderDate)
      }}</span>
      <span slot="orderServicechargeusd" slot-scope="text, record"
        >${{
          record.orderServicechargeusd === null
            ? 0
            : record.orderServicechargeusd
        }}/¥{{
          record.orderServicechargermb === null
            ? 0
            : record.orderServicechargermb
        }}</span
      >
      <span slot="orderState" slot-scope="text">
        <!--        :color="getState(text).color" -->
        <a-tag
          :style="{
            color: [
               'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'green',
              'green',
              '#108ee9',
              '#7B68EE',
            ][text],
            borderColor: [
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'darkturquoise',
              'green',
              'green',
              '#108ee9',
              '#7B68EE',
            ][text],
          }"
          >{{
            [
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.menuList.Uncompleted'),
              $tc('lang.orderAll.Finished'),
              $tc('lang.orderAll.Finished'),
              $tc('lang.orderAll.Draft'),
              $tc('lang.orderAll.Canceled'),
            ][text]
          }}</a-tag
        >
      </span>
    </a-table>
    <sup-from ref="supFrom" />
    <start-from ref="startFrom" />
  </div>
</template>
<script>
import startFrom from '../../views/downOrder/componentsGd/startFrom';
import supFrom from '../../views/downOrder/componentsSup/supFrom';
import moment from 'moment';
// const columns =

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      data: [],
      columns: [
        {
          title: this.$tc('lang.orderAll.Serial_Number'),
          align: 'center',
          width: 60,
          fixed: 'left',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.orderAll.Order_Number'),
          dataIndex: 'orderId',
          key: 'orderId',
          width: 300,
          align: 'center',
        },
        {
          title: this.$tc('lang.orderAll.Service_Date'),
          key: 'orderServicedate',
          dataIndex: 'orderServicedate',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'orderServicedate' },
        },
        {
          title: this.$tc('lang.orderAll.Vendor_name'),
          width: 140,
          align: 'center',
          dataIndex: 'orderFactoryname',
          key: 'orderFactoryname',
        },
        {
          title: this.$tc('lang.orderAll.PO_Number'),
          width: 140,
          align: 'center',
          dataIndex: 'productOrderId',
          key: 'productOrderId',
        },
        {
          title: this.$tc('lang.orderAll.Product_Name'),
          dataIndex: 'productnames',
          key: 'productnames',
          width: 120,
          align: 'center'
        },
        {
          title: this.$tc('lang.orderAll.Item_Number'),
          dataIndex: 'itemnumbers',
          key: 'itemnumbers',
          width: 120,
          align: 'center'
        },
        

      
        {
          title: this.$tc('lang.orderAll.Service_fee'),
          key: 'orderServicechargeusd',
          dataIndex: 'orderServicechargeusd',
          scopedSlots: { customRender: 'orderServicechargeusd' },
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.orderAll.Order_status'),
          width: 100,
          key: 'orderState',
          dataIndex: 'orderState',
          align: 'center',
          scopedSlots: { customRender: 'orderState' },
          // customRender: (text, record, index) => {
          //   //<a-tag color='pink'> 待确认</a-tag>
          //   if (text === '0') {
          //     return '待确认';
          //   } else if (text === '1') {
          //     return '待付款';
          //   } else if (text === '2') {
          //     return '待匹配';
          //   } else if (text === '3') {
          //     return '发布中';
          //   } else if (text === '4') {
          //     return '待服务';
          //   } else if (text === '5') {
          //     return '服务中';
          //   } else if (text === '6') {
          //     return '审核中';
          //   } else if (text === '7') {
          //     return '待翻译';
          //   } else if (text === '8') {
          //     return '待评价';
          //   } else if (text === '9') {
          //     return '已完成';
          //   } else if (text === '10') {
          //     return '草稿箱';
          //   } else if (text === '11') {
          //     return '已取消';
          //   }
          // },
        },
        {
          title: this.$tc('lang.orderAll.Operate'),
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'actionOne' },
          // width: '14%',
          align: 'center',
          visible: false,
          condition: true,
        },
      ],
      page: 1,
      size: 10,
      total: 10,
      // 删除
      loadingDe: false,
      // 取消
      loadingCen: false,
      // 恢复
      loadingInit: false,
      orderData: {},
      vendorName: '',
      dateTime: '',
      orderStatus: '92',
      // 当前用户信息
      user: {},
    };
  },
  created() {
    this.queryOrder();
  },
  // 数据状态处理全局
  computed: {
    // 验货下单表单提交的数据
    goodsDataList: {
      get() {
        return this.$store.state.downOrder.goodsDataList;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          goodsDataList: value,
        });
      },
    },
    // 表单提交全部数据
    containerData: {
      get() {
        return this.$store.state.supervision.containerData;
      },
      set(value) {
        this.$store.commit('supervision/save', {
          containerData: value,
        });
      },
    },
  },
  components: {
    'start-from': startFrom,
    'sup-from': supFrom,
  },
  methods: {
    // 整行点击事件
    clickHang(record, index) {
      const _this = this;
      return {
        on: {
          click: () => {
            this.$http
              .post('/hzwmj/workorder/selectById', {
                id: record.id,
              })
              .then(data => {
                if (data != null) {
                  const reastData = data.data;
                  const workorder = reastData.workorder;
                  const medias = reastData.medias;
                  const products = reastData.products;
                  console.log('workorder=====', workorder);
                  console.log('medias=====', medias);
                  console.log('products=====', products);
                  // 图片回显
                  let fileArray = [];
                  if (medias !== null) {
                    if (medias.length !== 0) {
                      console.log('medias111=====', medias);
                      medias.forEach(value => {
                        console.log('medias1121=====', medias);
                        const urlPath = this.config.urlImg + value.mediaPath;
                        fileArray.push({
                          uid: value.id,
                          name: value.mediaName,
                          url: urlPath,
                          status: 'done',
                        });
                      });
                    }
                  }
                  let foProduct = [];
                  if (products.length !== 0) {
                    products.forEach(value => {
                      foProduct.push({
                        productName: value.productName,
                        productModelid: value.productModelid,
                        orderId: value.productOrderid,
                        productCount: value.productCount,
                        productUnit: value.productUnit,
                        productArrivedate: value.productArrivedate,
                      });
                    });
                  }
                  _this.goodsDataList = {
                    formDataMap: {
                      // 工厂信息
                      orderFactoryname: workorder.orderFactoryname,
                      orderFactoryarea:
                        workorder.orderFactoryarea !== null
                          ? workorder.orderFactoryarea.split('/')
                          : [],
                      orderFactoryaddress: workorder.orderFactoryaddress,
                      orderFactoryperson: workorder.orderFactoryperson,
                      orderFactoryfixedtel: workorder.orderFactoryfixedtel,
                      orderFactorytel: workorder.orderFactorytel,
                      orderFactoryemail: workorder.orderFactoryemail,
                      // 我的信息
                      orderTrustcompany: workorder.orderTrustcompany,
                      orderTrustaddress: workorder.orderTrustaddress,
                      orderTrustperson: workorder.orderTrustperson,
                      orderTrustfixedtel: workorder.orderTrustfixedtel,
                      orderTrusttel: workorder.orderTrusttel,
                      orderTrustemail: workorder.orderTrustemail,
                      //验货时间
                      orderServicedate:
                        workorder.orderServicedate != null
                          ? moment(workorder.orderServicedate)
                          : null,
                      //检验水平
                      aql: workorder.orderLevel,
                      //致命缺陷
                      criterion: workorder.orderFataldefect,
                      //严重缺陷
                      serious: workorder.orderSeriousdefect,
                      //轻微缺陷
                      slight: workorder.orderMinordefect,
                      // 客户要求
                      orderRequire: workorder.orderRequire,
                    },
                    // 图片回显
                    fileList: {
                      fileArray: fileArray,
                    },
                    // 产品数据
                    tableDataList: foProduct,
                    modelType: true,
                  };
                  _this.containerData = {
                    formDataMap: {
                      // 工厂信息
                      orderFactoryname: workorder.orderFactoryname,
                      orderFactoryarea:
                        workorder.orderFactoryarea !== null
                          ? workorder.orderFactoryarea.split('/')
                          : [],
                      orderFactoryaddress: workorder.orderFactoryaddress,
                      orderFactoryperson: workorder.orderFactoryperson,
                      orderFactoryfixedtel: workorder.orderFactoryfixedtel,
                      orderFactorytel: workorder.orderFactorytel,
                      orderFactoryemail: workorder.orderFactoryemail,
                      // 我的信息
                      orderTrustcompany: workorder.orderTrustcompany,
                      orderTrustaddress: workorder.orderTrustaddress,
                      orderTrustperson: workorder.orderTrustperson,
                      orderTrustfixedtel: workorder.orderTrustfixedtel,
                      orderTrusttel: workorder.orderTrusttel,
                      orderTrustemail: workorder.orderTrustemail,
                      //验货时间
                      orderServicedate:
                        workorder.orderServicedate != null
                          ? moment(workorder.orderServicedate)
                          : null,
                      //检验水平
                      aql: workorder.orderLevel,
                      //致命缺陷
                      criterion: workorder.orderFataldefect,
                      //严重缺陷
                      serious: workorder.orderSeriousdefect,
                      //轻微缺陷
                      slight: workorder.orderMinordefect,
                      // 客户要求
                      orderRequire: workorder.orderRequire,
                    },
                    // 图片回显
                    // fileList: {
                    fileArray: fileArray,
                    // },
                    // 产品数据
                    tableData: foProduct,
                    modelType: true,
                  };
                  console.log('_this.goodsDataList=====', _this.goodsDataList);
                  console.log(_this);
                  if (workorder.orderType === '1') {
                    _this.$refs.startFrom.init();
                  }
                  if (workorder.orderType === '5') {
                    _this.$refs.supFrom.init();
                  }
                }
              })
              .catch(() => {
                console.log('12313');
              });
            console.log('record=====', record);
            console.log('index=====', index);
          },
        },
      };
    },
    // 条件查询
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.page = 1;
          this.size = 10;
          // console.log('Received values of form: ', values);
          this.orderStatus =
            values.orderStatus === undefined ? '92' : values.orderStatus;
          this.orderData = {
            // orderStatus:
            //   values.orderStatus === undefined ? '' : values.orderStatus,
            // orderType: values.orderType === undefined ? '' : values.orderType,
            productOrderId: values.productOrderId === undefined ? '' : values.productOrderId,
            productNames:
              values.productNames === undefined ? '' : values.productNames,
              itemNumbers:
              values.itemNumbers === undefined ? '' : values.itemNumbers,
              vendorName:
              values.vendorName === undefined ? '' : values.vendorName,
            personId: this.user.id,
          };
          this.queryOrder(this.orderData);
        }
      });
    },
    //立即支付
    action(record, e) {
      // 1-立即编辑，2-立即支付,3-恢复,4跳转到验货报告”选项卡
      console.log('===record==', record);
      if (e === 1) {
        if (record.orderType === '5') {
          this.$router.push({
            path: '/supervision',
            query: {
              id: record.id,
              orderId: record.orderId,
              type: 2,
            },
          });
        }
        if (record.orderType === '1') {
          this.$router.push({
            path: '/goods',
            query: {
              id: record.id,
              orderId: record.orderId,
              type: 2,
            },
          });
        }
      }
      if (e === 2) {
        this.$router.push({
          path: '/pay',
          query: {
            id: record.id,
            type: 2,
          },
        });
      }
      if (e === 4) {
        this.$router.push({
          path: '/reportManage',
        });
      }
      if (e === 3) {
        this.loadingInit = true;
        this.$http
          .post('/hzwmj/workorder/updateStatus', {
            orderNo: record.orderId,
            status: '10',
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingInit = false;
                console.log('========', buyData);
                // this.$router.push('/allorder');
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingInit = false;
          });
      }
    },
    /*下拉*/
    handleChange(value) {
      // this.add()
      console.log(`selected ${value}`);
    },
    /*查看报告编号*/
    queryReportList(value) {
      // this.add()
      this.$router.push({
        path: '/reportManage',
        query: {
          id: value.orderId,
        },
      });
    },
    /*检验时间*/
    onDateChange(date, dateString) {
      console.log(date, dateString);
      this.dateTime = dateString;
    },
    // 切换页码
    onChangePage(page) {
      this.page = page;
      this.queryOrder();
    },
    // 取消修改订单状态
    cancelButton() {
      this.queryOrder();
    },
    // 修改订单状态
    onOrderState(record, e) {
      // 4-删除订单,5-取消订单
      console.log('===del=', e);
      if (e === 5) {
        this.loadingCen = true;
        this.$http
          .post('/hzwmj/workorder/updateStatus', {
            orderNo: record.orderId,
            status: '11',
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingCen = false;
                // this.$router.push('/allorder');
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingCen = false;
          });
      } else {
        this.loadingDe = true;
        this.$http
          .get('/hzwmj/workorder/delete', {
            params: {
              id: record.id,
            },
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              if (buyData === true) {
                this.loadingDe = false;
                this.queryOrder();
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {
            this.data = [];
            this.total = 0;
            this.loadingDe = false;
          });
      }
    },
    // 表格请求
    queryOrder() {
      // 获取用户sessionStorage信息
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      }
      this.$http
        .post('/hzwmj/workorder/getOrderPageList', {
          page: this.page,
          size: this.size,
          // orderStatus: this.orderData.orderStatus,
          // orderType: this.orderData.orderType,
          productOrderId: this.orderData.productOrderId,
          vendorName: this.orderData.vendorName,
          productNames: this.orderData.productNames,
          itemNumbers: this.orderData.itemNumbers,
          dateTime: this.dateTime,
          personId: this.user.id,
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            this.data = buyData.records;
            this.total = buyData.total;
            this.loading = false;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less">
.page-table-fprm-all {
  padding-top: 10px;
  padding-bottom: 40px;
  border-left: 3px solid #f0f2f5;
  border-right: 2px solid #f0f2f5;
  border-bottom: 2px solid #a7a7a7;
  border-radius: 10px;
  margin-top: 3%;
  .page-form-queryheder {
    border-radius: 10px;
    border-bottom: 2px solid #a2a2a2;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    width: 97%;
    margin: 20px 0;
  }
}
</style>
